(function() { window.GUID_77dead6e_1fb6_40b5_acf9_6dfd0a4aa739 = { getGuid: function() { return "77dead6e-1fb6-40b5-acf9-6dfd0a4aa739"; } }; })();
var CompuSport;
(function (CompuSport) {
    let Send;
    (function (Send) {
        function PrepareData(me) {
            var dynamicItem = {};
            if (me.RefreshElementIds != null && me.RefreshElementIds[0] != "") {
                $.each(me.RefreshElementIds, function (index, id) {
                    AppendPropertiesToDynamicItem(id, dynamicItem);
                });
            }
            if (me.BindElementIds != null && me.BindElementIds[0] != "") {
                $.each(me.BindElementIds, function (index, id) {
                    AppendPropertiesToDynamicItem(id, dynamicItem);
                });
            }
            return dynamicItem;
        }
        Send.PrepareData = PrepareData;
        function AppendPropertiesToDynamicItem(identifier, item) {
            var element = $('#' + identifier);
            var context = element.data('context');
            //Essaye de le trouver dans le LoadParamsHelper
            if (element.length == 0) {
                element = $('#LoadParam_' + identifier);
            }
            //Permet de fonctionner avec les radio buttons grace à ca puisque
            //le radio button n'a pas de Id
            if (element.length == 0) {
                element = $('[name="' + identifier + '"]:checked');
            }
            if (element.length > 0) {
                if (context != undefined && context.PrepareDataToSend != undefined) {
                    context.PrepareDataToSend(item);
                }
                else if (element[0].type == 'checkbox') {
                    let value = element[0].checked;
                    item[identifier] = value;
                }
                else {
                    let value = element.val();
                    item[identifier] = value;
                }
            }
        }
        function AppendHasChangedElementsToForm(form) {
            var inputs = form.find('.IHasChanged');
            let hasChangedContainer = form.find('.HasChangedContainer');
            if (hasChangedContainer.length == 0) {
                form.append("<div class='HasChangedContainer'></div>");
                hasChangedContainer = form.find('.HasChangedContainer');
            }
            $.each(inputs, function (e) {
                var control = $(this).data('context');
                if (control && control.HasChanged()) {
                    let inputNames = control.InputNames();
                    let end = inputNames.length;
                    for (var i = 0; i < end; i++) {
                        let inputName = inputNames[i];
                        //$('[name="' + inputName + '"]',hasChangedContainer).remove();
                        //hasChangedContainer.find('[name="' + inputName.replaceAll(".","\\.") + '"]').remove();
                        hasChangedContainer.find('[name="' + inputName + '.HasChanged"]').remove();
                        hasChangedContainer.append("<input type='hidden' name='" + inputName + ".HasChanged' value='true' />");
                    }
                }
            });
        }
        Send.AppendHasChangedElementsToForm = AppendHasChangedElementsToForm;
    })(Send = CompuSport.Send || (CompuSport.Send = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=SendHelper.js.map
